module.exports = __webpack_public_path__ + "img/sintomas podridão frutos.18219962.webp";